const apiEndPoints = {
    feedData: `photos?page=:pageId&&client_id=${process.env.REACT_APP_CLIENT_ID}`,
};

export default apiEndPoints;
